"use strict";
// Copyright (c) 2021 by Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Builder = void 0;
const composition_api_1 = require("@vue/composition-api");
const vuedraggable_1 = __importDefault(require("vuedraggable"));
const Container_1 = require("../Container");
const Builder_hooks_1 = require("./Builder.hooks");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.Builder = composition_api_1.defineComponent({
    name: 'Builder',
    components: { Container: Container_1.Container, Draggable: vuedraggable_1.default },
    props: Builder_hooks_1.builderProps,
    setup: Builder_hooks_1.useBuilder,
    template: `
    <div :id="id" class="builder"
         :class="{ '--with-controls': resolvedConfig.showControls, '--no-min-row-height': !resolvedConfig.minRowHeight }">
      <component v-if="gridTemplate" is="style" v-html="gridTemplate" />
      <button v-if="showAddContainerBtn" class="builder__container --add-container"
              type="button" @click="() => addContainer('prepend')">
        <i class="fa fa-lg fa-plus"></i>
      </button>
  
      <Draggable :list="structureToDisplay" handle=".--container-handler"
                 :group="{ name: 'containers', pull: true, put: 'containers' }"
                 ghostClass="--container-ghost" :disabled="!resolvedConfig.showControls">
  
        <Container class="builder__container" :class="{ '--selected': selectedContainer === c.container, '--hover': hoveredContainer === c.container }"
                   v-for="(c, i) in structureToDisplay" :key="'container-'+c.container+'-'+i"
                   :containers="containers" :definition="c" :index="i" :columns="resolvedConfig.columns"
                   :controls="resolvedConfig.controls" :showControls="resolvedConfig.showControls"
                   :component="containerComponent" :elementProps="elementProps"
                   v-on="$listeners" @click="selectContainer(c.container)"
                   @mouseover.native="hoverContainer(c.container)" @mouseleave.native="hoverContainer(null)"
                   @clone="cloneContainer">
  
          <Draggable class="builder__container-inner" :list="c.modules" handle=".--module-handler"
                     :group="{ name: 'modules', pull: true, put: 'modules' }"
                     ghostClass="--module-ghost" :disabled="!resolvedConfig.showControls">
  
            <component class="builder__module" :class="{ '--selected': selectedModule === m.module, '--hover': hoveredModule === m.module }"
                       :is="moduleComponent" v-for="(m, j) in c.modules" :key="'module-'+m.module+'-'+j"
                       :definition="m" @update:definition="(d) => updateModuleDefinition(i, d)"
                       :containerIndex="i" :index="j" :modules="modules"
                       :controls="resolvedConfig.controls" :showControls="resolvedConfig.showControls"
                       :columns="resolvedConfig.columns" :elementProps="elementProps"
                       v-on="$listeners" @select="selectModule(m.module, true)" @deselect="selectModule(null, true)" @toggle="selectModule(m.module)"
                       @mouseover.native.stop="hoverModule(m.module)" @mouseleave.native.stop="hoverModule(null)"
                       @clone="(def, mod) => cloneModule(i, def, mod)" />
  
            <button v-if="resolvedConfig.showControls" slot="footer"
                    class="builder__module --add-module" type="button" tabindex="0"
                    @click.stop="addModule(c.container, i)">
              <i class="fa fa-lg fa-plus"></i>
            </button>
          </Draggable>
  
        </Container>
      </Draggable>
  
      <button v-if="showAddContainerBtn && structureToDisplay.length > 0" class="builder__container --add-container"
              type="button" @click="() => addContainer('append')">
        <i class="fa fa-lg fa-plus"></i>
      </button>
    </div>
  `
});
//# sourceMappingURL=Builder.js.map